import { ReferralApplicationStatus, ResumeType } from '../../api-client';

export function referralApplicationStatusToString(status: ReferralApplicationStatus): string {
  return status;
}

export function stringToReferralApplicationStatus(
  status: string | undefined
): ReferralApplicationStatus | undefined {
  if (!status) return undefined;
  const validStatuses = Object.values(ReferralApplicationStatus) as string[];
  if (validStatuses.includes(status)) {
    return status as ReferralApplicationStatus;
  }
  return undefined;
}

export function getReferralApplicationStatusLabel(status: ReferralApplicationStatus): string {
  switch (status) {
    case ReferralApplicationStatus.PENDING:
      return 'Ожидает обработки';
    case ReferralApplicationStatus.REVIEWING:
      return 'На рассмотрении';
    case ReferralApplicationStatus.ACCEPTED:
      return 'Принято';
    case ReferralApplicationStatus.REJECTED:
      return 'Отклонено';
    default:
      return status;
  }
}

export function getResumeTypeLabel(resumeType: ResumeType): string {
  switch (resumeType) {
    case ResumeType.FILE:
      return 'Файл';
    case ResumeType.URL:
      return 'URL';
    default:
      return resumeType;
  }
}
